import {storeToRefs} from "pinia";

export default defineNuxtPlugin((nuxtApp) => {
  const settingsStore = useSettingsStore()
  const { settings } = storeToRefs(settingsStore);
  onNuxtReady(async () => {
    try {
      await settingsStore.loadPublic()
      const { tawk_to, tawk_property_id: propertyId, tawk_widget_id: widgetId } = settings.value
      if (!tawk_to || !propertyId || !widgetId) return
      const { default: TawkMessengerVue } = await import('@tawk.to/tawk-messenger-vue-3')
      nuxtApp.vueApp.use(TawkMessengerVue, { propertyId, widgetId })
    } catch (error) {
      console.error('Tawk loading failed:', error)
    }
  })
})
